import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  isWtAdmin: false,
  isWtAdminSuper: false,
  isAdmin: false,
  isNonAdmin: false,
  emailNotConfirmed: false,
  passwordChanged: false,
  isTeamLeader: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
